export default "__VITE_ASSET__SVdN9pnb__"